import React from "react";
import MuiAlert from "@material-ui/lab/Alert";
import { Snackbar } from "@material-ui/core";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Notification = ({ ...props }) => {
 // const [duration, setDuration] = React.useState(3500);

  let duration=3500;

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      focusable={false}
      open={props.msgObj.isOpen}
      autoHideDuration={props.msgObj.duration==undefined?duration:(props.msgObj.msgtype == 1
        ?props.msgObj.duration:duration)}
      onClose={props.closeNoticeModal}
    >
      <Alert
        onClose={props.closeNoticeModal}
        focusable={false}
        severity={
          props.msgObj.msgtype == 1
            ? "success"
            : props.msgObj.msgtype == 0
            ? "error"
            : ""
        }
        sx={{
          width:
            props.msgObj.msgtype == 1
              ? "100%"
              : props.msgObj.msgtype == 0
              ? "100%"
              : "0%",
        }}
      >
        {props.msgObj.msg}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
